import { APIPaths } from "../api-config";
import BaseApi from "../base-api";

export class StoreArticleApi extends BaseApi {
  async getArticleList(
    parameters: APIPaths["/store-app/article/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/store-app/article/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/store-app/article/list", { params: parameters })).data;
  }
}
